import React, { memo, useCallback, useState } from 'react';
import Input from '../../../../../../../../shared/design-system/components/input';
import './call-logs-search.scss';
import SearchGrey from '../../../../../../../../shared/components/images/search-grey';
import { InputIconConfig } from '../../../../../../../../shared/design-system/components/input/types';

interface IProps {
  search: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

const CallLogsSearch: React.FC<IProps> = memo(({ search, onChange, placeholder = 'Search by name or number' }) => {
  const [localSearch, setLocalSearch] = useState(search);

  const handleChange = useCallback((value?: string) => {
    setLocalSearch(value ?? '');
  }, []);

  const handleKeyPress = useCallback(
    (e: React.KeyboardEvent<HTMLInputElement>) => {
      if (e.key === 'Enter') {
        onChange(localSearch);
      }
    },
    [localSearch, onChange],
  );

  const handleClear = useCallback(() => {
    setLocalSearch('');
    onChange('');
  }, [onChange]);

  const getSearchIcons = (): InputIconConfig[] => {
    const icons: InputIconConfig[] = [];

    if (localSearch && localSearch?.length > 0) {
      icons.push({
        place: Input.IconPlace.Right,
        identifier: 'close-o cursor-pointer',
        onClick: handleClear,
      });
    }

    return icons;
  };

  return (
    <div className="call-logs-search">
      <SearchGrey />
      <Input
        value={localSearch}
        onChange={handleChange}
        icons={getSearchIcons()}
        onKeyPress={handleKeyPress}
        placeholder={placeholder || "Search by name or number"}
        className="call-logs-search__input"
      />
    </div>
  );
});

CallLogsSearch.displayName = 'CallLogsSearch';

export default CallLogsSearch;
